import axios from "axios";
import { isEmpty } from "../../../../../../../../../common/utils";
import ApiUrls from "../../../../../../../../../api/project/ApiUrls";

export const ocrImgFile = ({ ocrFile, user }) =>
  new Promise((resolve, reject) => {
    const { uid } = user;

    /*  files:[{
            diaryId:"DIARY281"
            fileName:"a1_3_2-杜信龍-老.pdf"
            hasOcr:"OCR__e20123b7-afc7-42a3-aa48-aa14dd091859"
            imgUrl:"a1_3_2-杜信龍-老.pdf/1.png"
            ocrFileName:"1.png"
            ocrPage:"1"
            userId: "8CcRIlpr5SYRXPBwtZae1j21xJE3"
        }]
    */

    const fileObj = ocrFile.reduce((acc, cur) => {
      const { fileName, ocrFileName, checked } = cur;

      // 勾選的才做 OCR
      if (!checked) return acc;
      // 勾選且已經ocr過的，不再ocr
      if (checked && Object.keys(cur).some((key) => key === "ocrContent")) {
        return acc;
      }

      if (!(fileName in acc)) {
        acc[fileName] = [];
      }
      acc[fileName].push(ocrFileName);

      return acc;
    }, {});

    const entry = {
      username: uid,
      files: fileObj,
    };

    axios
      .post(ApiUrls.generateOcrResult, { ...entry })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        const customErr = new Error("圖片 OCR 失敗");
        reject(customErr);
      });
  });

export const generateOcrResultApi = async ({
  user,
  ocrFile,
  onSuccess,
  onError,
  onUploadLoading,
}) => {
  if (isEmpty(ocrFile)) onError({ message: "ocrFile is empty!" });
  try {
    if (onUploadLoading) onUploadLoading(true);
    //
    const res = await ocrImgFile({
      ocrFile,
      user,
    });

    const { status } = res;

    if (status === 200) {
      const folderName = [
        ...new Set([
          ...ocrFile.filter((el) => el.checked).map((el) => el.fileName),
        ]),
      ]
        .map((el) => `"${el}"`)
        .join(",");

      onSuccess({ userId: user.uid, folderName });
    } else {
      if (onUploadLoading) onUploadLoading(false);
      if (onError) onError({ message: status });
    }
  } catch (err) {
    if (onUploadLoading) onUploadLoading(false);
    if (onError) onError({ message: err });
  }
};
